module.exports = __webpack_public_path__ + "static/media/ikea.1499d4d2.svg";